import {defaultPositionY} from './defaultPositionY';
import {windowHeight} from './windowHeight';

export const getPositionY = (position_key: string, height: number): number => {
    const positionY = Number(localStorage.getItem(position_key));

    return positionY && windowHeight() > positionY ? positionY : defaultPositionY(height);
};
